export const basePath = '/coaching/comments'

const routes = {
  root: basePath,
  list: (): string => basePath,
}

export default routes
